import React, { useEffect } from "react";
import { useGetMe } from "../../../hooks";
import "./Profile.scss";
import { Box, Menu } from "../../../components/common";
import { Stack } from "@mui/material";

const menuItems = [
  {
    label: "Profile",
    path: "/profile",
  },
  {
    label: "ICF Terms",
    path: "/profile/icf-terms",
  },
  {
    label: "Account Balance",
    path: "/profile/account-balance",
  },
  {
    label: "Statements",
    path: "/profile/statements",
  },
  {
    label: "Notifications",
    path: "/profile/notifications",
  },
  {
    label: "Documents",
    path: "/profile/documents",
  },
];

const ProfileLayout = ({ children }) => {
  const { data: me, refetch } = useGetMe();

  // TODO: remove this from everywhere
  useEffect(() => {
    refetch();
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });

    document.body.classList.add("profile");

    return () => {
      document.body.classList.remove("profile");
    };
  }, []);

return <main className="profile">
  <Box className="banner">
    <h2 className="banner__message">
      Welcome back, {me?.firstname} {me?.lastname}!
    </h2>
    <div className="decorations black">
      <div className="d1 light-blue circle"></div>
      <div className="d2 light-blue outline circle"></div>
      <div className="d3 yellow circle"></div>
      <div className="d4 light-blue circle"></div>
      <div className="d5 yellow circle"></div>
      <div className="d6 light-blue circle"></div>
      <div className="d7 yellow outline circle"></div>
    </div>
  </Box>
  
  <Stack direction={{ xs: "column", md: "row" }} spacing={4} paddingTop={6}>
    <Menu items={menuItems} />
    {children}
  </Stack>
</main>
};

export default ProfileLayout;
